<template>
  <div class="d-flex body">
      <div class="col-md-3">
          <PanelRequest :selectedSolicitacao="dataDetails"></PanelRequest>
      </div>
      <div class="col-md-9 container-tab">
        <b-tabs  class="container-tab" >
            <b-tab class="container-tab" :title="'Cliente'">

                <template slot="title">
                    <div><span class="d-md-down-none pl-1 text-third text-tabs">Cliente</span></div>
                </template>

                <ClientDetails @cancelarSolicitacao="cancelarSolicitacao" :selectedSolicitacao="dataDetails"></ClientDetails>
            </b-tab>

            <b-tab :title="'Anexos'">
                <template slot="title">
                    <div><span class="d-md-down-none pl-1 pr-1 text-third text-tabs">Anexos</span></div>
                </template>
                <AttachmentsDetails @cancelarSolicitacao="cancelarSolicitacao" :selectedSolicitacao="dataDetails"></AttachmentsDetails>
            </b-tab>

            <b-tab :title="'Condições de Pagamento'">
            <template slot="title">
                <div><span class="d-md-down-none pl-1 pr-1 text-third text-tabs">Condições de Pagamento</span></div>
            </template>
                <PaymentConditionsDetails @cancelarSolicitacao="cancelarSolicitacao" :selectedSolicitacao="dataDetails"></PaymentConditionsDetails>
            </b-tab>
        </b-tabs>
      </div>
        <b-modal ref="cancelarSolicitacaoModal" centered hide-footer title="REPROVAÇÃO"  :no-close-on-backdrop="true">
             <div class="popupRequest">
                <div class="title-popupRequest-pt2"> Atenção! </div>
                <div class="subtitle-popupRequest-pt3"> Adicione um motivo para a reprova </div>
                <textarea v-model="pendencia" class="textareaRequest" placeholder="Digite uma breve observação sobre o motivo da reprova">  </textarea>
                <div class="btn-pt2">
                    <div> <button class="whiteButton-2" v-on:click="closeModalCancelar"> CANCELAR </button> </div>
                    <div> <button class="greenButton-2" v-on:click="repproveRequest(dataDetails.id,pendencia)"> REPROVAR </button> </div>
                </div>
            </div>
        </b-modal>
  </div>
</template>

<script>

import RequestDetails from './requestDetails'
export default RequestDetails

</script>

<style scoped>
.container-tab{
    height: 100%;
}
.body{
    height: 100%;
}
.title-popupRequest-pt2{
    font: normal normal bold 32px/43px Segoe UI;
    letter-spacing: 0px;
    color: #008148;
}
 .btn-pt2{
          display: flex;
          gap: 2em;
        }
#img-pincipal{
    height: 100%;
    width: 100%;
    object-fit: cover;
}

#body-details{
    height: 60vh;
}
 .textareaRequest{
    resize: none;
    width: 452px;
    height: 92px;
    border-radius: 10px;
    padding: 0.5rem;
    font: normal normal normal 18px/27px Segoe UI;
}
.title-popupRequest-pt2{
    font: normal normal bold 32px/43px Segoe UI;
    letter-spacing: 0px;
    color: #008148;
}
.subtitle{
    font-size: 18px;
    color: #008148;
    font-weight: bold;
}

.list-popupRequest-pt2{
    font: normal normal 600 22px/30px Segoe UI;
    letter-spacing: 0px;
    color: #2A2A2A;
    text-align: center;
}
.subtitle-popupRequest-pt2{
    font: normal normal normal 20px/27px Segoe UI;
    letter-spacing: 0px;
    color: #2A2A2A;
    padding-bottom: 10px;
}
.popupRequest{
    display: grid;
    justify-content: center;
    align-items: center;
    justify-items: center;
    gap: 1rem;
}
.whiteButton-2{
    background: #CFCFCF 0% 0% no-repeat padding-box;
    border-radius: 4px;
    width: 150px;
    height: 45px;
    font: normal normal 600 15px/27px Segoe UI;
    color: #707070;
    border: none;
}
.greenButton-2{
    background: #008148 0% 0% no-repeat padding-box;
    border-radius: 4px;
    width: 150px;
    height: 45px;
    font: normal normal 600 15px/27px Segoe UI;
    color: #FFFFFF;
    border: none;
}
.subtitle-popupRequest-pt3{
    font: normal normal normal 20px/27px Segoe UI;
    letter-spacing: 0px;
    color: #2A2A2A;
    padding-bottom: 10px;
}
.input-details{
    width: 100%;
    height: 35px;
    background-color: #F1F1F1;
    border: 1px solid #D4D9DE;
    border-radius: 5px;
}

.label-details{
    font-size: 15px;
    color: black;
    margin-bottom: 0px;

}
.result-details{
    font-size: 16px;
    font-weight: bold;

}

.head-right {
  height: 59px;
  display: flex;
  width: 100%;
  background: #ECEFF1 0% 0% no-repeat padding-box;
  border: 1px solid #CFD8DC;
  border-radius: 4px 4px 0px 0px;
  opacity: 1;
}

#details-board{
    height: 80vh;
    width: 100%;
    background-color:white;
}

.text-tabs{
    color: #008148;
}
#card-details{
    width: 100%;
    border: 1px solid rgb(202, 202, 202);
    background-color: white;
    border-radius: 5px;
}

#footer-card-details{
    display: flex;
    font-size: 35px;
}

#nameTower{
    color: rgb(90, 90, 90);
    font-size: 30px;
    font-weight: bold;
}

#card-img{
    height: 250px;
}

#info{
    height: 50px;
    width: 100%;
    font-size: 22px;
    background-color: #008148;
    padding-top: 15px;
    color: white;
}
hr{
    width: 95%;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/requests/components/requestDetails/requestDetails.vue